import UserPage from './user'

export { UserPage }
